import { BoneTypeEnum } from '../Models/CaseModel.js';
import { MeasuresCalculator } from "./MeasuresCalculator.js";
/**
 * Binds measures calculations.
 */
export class MeasuresController {
    constructor(main, measuresCalculator = MeasuresCalculator) {
        this._main = main;
        this._model = main.model;
        this.measuresCalculator = new measuresCalculator(main);
    }
    updateMeasureInModel(...propertiesName) {
        for (const propertyName of propertiesName) {
            this._model.measures[propertyName] = this.measuresCalculator[propertyName];
        }
    }
    /**
     * Binds deformity AP measures calculations.
     */
    bindMechanicalAxisAP() {
        const mechAxisAP = this._main.toolsAP.mechanicalAxis;
        const boneType = this._main.caseModel.boneType;
        if (boneType === BoneTypeEnum.LongLeg) {
            mechAxisAP.addEventListener('updated', () => {
                this.updateMeasureInModel("def_ap_MAD", "def_ap_JLCA", "def_ap_kneeTranslation", "def_ap_fullLength");
            });
        }
        if (boneType === BoneTypeEnum.Femur || boneType === BoneTypeEnum.LongLeg) {
            mechAxisAP.addEventListener('updated', () => {
                this.updateMeasureInModel("def_ap_LPFA", "def_ap_mLDFA", "def_ap_MNSA", "def_ap_MPFA", "def_ap_aLDFA", "def_ap_apexFemur", "def_ap_apexFemurSign", "def_ap_femurLength");
            });
        }
        if (boneType === BoneTypeEnum.Tibia || boneType === BoneTypeEnum.LongLeg) {
            mechAxisAP.addEventListener('updated', () => {
                this.updateMeasureInModel("def_ap_MPTA", "def_ap_LDTA", "def_ap_apexTibia", "def_ap_apexTibiaSign", "def_ap_tibiaLength");
            });
        }
    }
    /**
    * Binds contralateral measures calculations.
    */
    bindControlateralMechanicalAxis() {
        const contralateral = this._main.toolsAP.contralateralMechanicalAxis;
        const boneType = this._main.caseModel.boneType;
        if (boneType === BoneTypeEnum.LongLeg) {
            contralateral.addEventListener('updated', () => {
                this.updateMeasureInModel("def_ap_MAD_ctrlateral", "def_ap_JLCA_ctrlateral", "def_ap_kneeTranslation_ctrlateral", "def_ap_fullLength_ctrlateral");
            });
        }
        if (boneType === BoneTypeEnum.Femur || boneType === BoneTypeEnum.LongLeg) {
            contralateral.addEventListener('updated', () => {
                this.updateMeasureInModel("def_ap_LPFA_ctrlateral", "def_ap_mLDFA_ctrlateral", "def_ap_MNSA_ctrlateral", "def_ap_MPFA_ctrlateral", "def_ap_aLDFA_ctrlateral", "def_ap_femurLength_ctrlateral");
            });
        }
        if (boneType === BoneTypeEnum.Tibia || boneType === BoneTypeEnum.LongLeg) {
            contralateral.addEventListener('updated', () => {
                this.updateMeasureInModel("def_ap_MPTA_ctrlateral", "def_ap_LDTA_ctrlateral", "def_ap_tibiaLength_ctrlateral");
            });
        }
    }
    /**
     * Binds deformity lateral measures calculations.
     */
    bindMechanicalAxisLT() {
        const mechAxisLT = this._main.toolsLT.mechanicalAxis;
        mechAxisLT.addEventListener('updated', () => {
            this.updateMeasureInModel("def_lt_kneeTranslation", "def_lt_PDFA", "def_lt_ADTA", "def_lt_PPTA", "def_lt_apexTibia", "def_lt_apexTibiaSign");
        });
    }
}
//# sourceMappingURL=MeasuresController.js.map